'use client';

import {
  Box,
  FormControl,
  FormLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';

import type { CreateSparkEngineWizardState } from '../createSparkEngineWizardState';

interface WarmCapacitySectionProps {
  state: CreateSparkEngineWizardState;
  update: (partial: Partial<CreateSparkEngineWizardState>) => void;
}

export const WarmCapacitySection = ({
  state,
  update,
}: WarmCapacitySectionProps) => (
  <Box paddingX='min(100px, 6vw)'>
    <Stack gap='24px' maxWidth='540px'>
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <Stack gap='8px'>
          <Typography variant='h6'>Warm Capacity</Typography>
          <Typography variant='body2' color='text.secondary'>
            Pre-allocate resources so the engine starts instantly without
            waiting for provisioning.
          </Typography>
        </Stack>
        <Switch
          checked={state.warmCapacityEnabled}
          onChange={(e) => update({ warmCapacityEnabled: e.target.checked })}
        />
      </Stack>

      <Stack direction='row' gap='16px'>
        <FormControl fullWidth disabled={!state.warmCapacityEnabled}>
          <FormLabel>
            <Typography variant='subtitle1' color='inherit'>
              vCPU
            </Typography>
          </FormLabel>
          <TextField
            size='small'
            type='number'
            disabled={!state.warmCapacityEnabled}
            value={state.warmCapacityEnabled ? state.warmVcpu : ''}
            onChange={(e) =>
              update({
                warmVcpu: Math.max(1, parseInt(e.target.value) || 1),
              })
            }
            slotProps={{ htmlInput: { min: 1 } }}
            fullWidth
          />
        </FormControl>

        <FormControl fullWidth disabled={!state.warmCapacityEnabled}>
          <FormLabel>
            <Typography variant='subtitle1' color='inherit'>
              Memory (GiB)
            </Typography>
          </FormLabel>
          <TextField
            size='small'
            type='number'
            disabled={!state.warmCapacityEnabled}
            value={state.warmCapacityEnabled ? state.warmMemory : ''}
            onChange={(e) =>
              update({
                warmMemory: Math.max(1, parseInt(e.target.value) || 1),
              })
            }
            slotProps={{ htmlInput: { min: 1 } }}
            fullWidth
          />
        </FormControl>

        <FormControl fullWidth disabled={!state.warmCapacityEnabled}>
          <FormLabel>
            <Typography variant='subtitle1' color='inherit'>
              Storage (GB)
            </Typography>
          </FormLabel>
          <TextField
            size='small'
            type='number'
            disabled={!state.warmCapacityEnabled}
            value={state.warmCapacityEnabled ? state.warmStorage : ''}
            onChange={(e) =>
              update({
                warmStorage: Math.max(1, parseInt(e.target.value) || 1),
              })
            }
            slotProps={{ htmlInput: { min: 1 } }}
            fullWidth
          />
        </FormControl>
      </Stack>
    </Stack>
  </Box>
);
